import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { TurnoPorTramiteModel } from 'src/app/models/turnoPorTramite.model';
import { UrlControl } from 'src/app/shared/models/generic.model';


import Chart from 'chart.js';
import { DataSet, ChartDTO, DataChart } from 'src/app/shared/models/chart';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { PromedioAtencionVentanilla } from 'src/app/models/promedioAtencionVentanilla.model';
import { PromedioEsperaTramite } from 'src/app/models/promedioEsperaTramite.model';
import { SwiperConfigInterface, SwiperComponent, SwiperDirective } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-tablero-de-control',
  templateUrl: './tablero-de-control.component.html',
  styleUrls: ['./tablero-de-control.component.scss']
})
export class TableroDeControlComponent implements OnInit, OnDestroy {

  // Variable que usa el componente de swiper que almacena la configuración
  public config: SwiperConfigInterface;


  @ViewChild(SwiperDirective, { read: false }) directiveRef?: SwiperDirective;

  // Variable que almacena el valor del parámetro de TIEMPO_ACTUALIZACION_TABLERO_DE_CONTROL
  // en milisegundos, por defecto tiene dos minutios
  paramTimeAutoUpdate = 120000;
  // Listado de colores para las gáficas
  colorPallete: string[] = [];

  /**
   * Variables para el reporte turnos por trámite
   */

  // Variable para el identificador del spiner, se usa para indicar cuando debe mostrarse o esconder.
  spinnerByTurnosPorTramiteId = 'spTramiteTurno';
  // Listado de datos para la gráfica 1
  turnoPorTramiteModel: TurnoPorTramiteModel[] = [];
  labelsEstadosTurnosPorTramite = [];
  isAutoUpdateTurnosByTramite = true;
  dataSetsTurnosPorTramite: DataSet[] = [];
  dataSetsTableTurnosPorTramite: DataSet[] = [];
  // Bandera para indicar si estan los datos para habilitar el excel
  isDataAviableTurnosPorTramite = false;
  @ViewChild('canvasTurnoPorTramite') inCanvasTurnoPorTramite;


  /**
   * Variables para el reporte tiempo promedio de atención por ventanilla
   */

  spinnerByPromedioAtencionVentanillaId = 'spPromedioAtencionVentanilla';
  promedioAtencionVentanilla: PromedioAtencionVentanilla[] = [];
  labelsEstadosPromedioAtencionVentanilla = [];
  isAutoUpdatePromedioAtencionVentanilla = true;
  dataSetsPromedioAtencionVentanilla: DataSet[] = [];
  dataSetsTablePromedioAtencionVentanilla: DataSet[] = [];
  isDataAviablePromedioAtencionVentanilla = false;
  @ViewChild('canvasPromedioAtencionVentanilla') inCanvasPromedioAtencionVentanilla;


  /**
   * Variables para el reporte tiempo promedio de espera por trámite
   */
  spinnerByPromedioEsperaTramiteId = 'spPromedioEsperaTramite';
  promedioEsperaTramite: PromedioEsperaTramite[] = [];
  labelsEstadosPromedioEsperaTramite = [];
  isAutoUpdatePromedioEsperaTramite = true;
  dataSetsPromedioEsperaTramite: DataSet[] = [];
  dataSetsTablePromedioEsperaTramite: DataSet[] = [];
  isDataAviablePromedioEsperaTramite = false;
  @ViewChild('canvasPromedioEsperaTramite') inCanvasPromedioEsperaTramite;

  constructor(
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService
  ) { }

  ngOnInit() {

    this.obtenerTiempoActualizacionTableroDeControl().then(param => {

      this.paramTimeAutoUpdate = param;

      this.config = {
        a11y: true,
        direction: 'horizontal',
        slidesPerView: 1,
        keyboard: true,
        mousewheel: false,
        scrollbar: false,
        navigation: true,
        pagination: false,
        autoplay: {
          delay: +this.paramTimeAutoUpdate,
          disableOnInteraction: false,
          reverseDirection: false,
          stopOnLastSlide: false,
          waitForTransition: false
        },
      };

      this.loadColorsPallete();
      this.indexChange(0);
    });
  }

  /**
   * Método que se ejecuta cuando un item del swiper cambia,
   * recibe el index del item actual
   */
  indexChange(index: number) {
    switch (index) {
      case 0: {
        this.loadTurnosPorTramites();
        break;
      }
      case 1: {
        this.loadPromedioAtencionVentanilla();
        break;
      }
      case 2: {
        this.loadPromedioEsperaTramite();
        break;
      }
    }
  }

  /**
   * Carga la paleta de colores de la gráfica
   */
  loadColorsPallete() {
    this.colorPallete.push('rgba(40,239,26,1)');
    this.colorPallete.push('rgba(243,123,36,1)');
    this.colorPallete.push('rgba(243,36,54,1)');
    this.colorPallete.push('rgba(243,36,157,0.9)');
    this.colorPallete.push('rgba(36,54,243,0.8)');
    this.colorPallete.push('rgba(225,99,99,1)');
    this.colorPallete.push('rgba(255,214,146,1)');
    this.colorPallete.push('rgba(210,250,251,1)');
    this.colorPallete.push('rgba(16,94,98,1)');
  }


  /**
   * Carga los turnos por tramites,
   * genera los datos de la tabla y crea la correspondiente gráfica.
   */
  private loadTurnosPorTramites() {
    // Indica que no se puede descargar el excel hasta que cambie el estado a true
    this.isDataAviableTurnosPorTramite = false;
    // Muestra el spinner mientras carga los datos nuevos
    this.spinner.show(this.spinnerByTurnosPorTramiteId);
    this.getDataTurnosPorTramite().then(turnosPorTramite => {
      this.isDataAviableTurnosPorTramite = true;
      this.turnoPorTramiteModel = turnosPorTramite;
      this.createGraphicTurnosPorTramite(turnosPorTramite);
      setTimeout(() => {
        this.spinner.hide(this.spinnerByTurnosPorTramiteId);
      }, 500);
    }).catch(err => {
      setTimeout(() => {
        this.spinner.hide(this.spinnerByTurnosPorTramiteId);
      }, 500);
      console.error(err);
      this.catchException('No es posible Cargar los Trámites');
    });
  }

  /**
   * Función que obtiene los trámites que se encuentran activos
   *  y tienen turnos asignados con diferentes estados
   */
  private getDataTurnosPorTramite(): Promise<TurnoPorTramiteModel[]> {
    return new Promise((resolve, reject) => {
      let turnosPorTramite: TurnoPorTramiteModel[] = [];
      const serviceProvider = 'turnosPorTramite';
      const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
      const promise: Promise<any> = this.global.getGenerico(url).toPromise();
      promise.then(
        data => {
          turnosPorTramite = data as TurnoPorTramiteModel[];
          resolve(turnosPorTramite);
        }
      ).catch(err => {
        reject(err);
      });
    });
  }

  /**
   * Método que genera la gráfica de turnos por trámite a partir de los datos recibidos.
   * @param data listado de turnos por trámites.
   */
  private createGraphicTurnosPorTramite(data: TurnoPorTramiteModel[]) {
    const ctx = this.inCanvasTurnoPorTramite.nativeElement.getContext('2d');

    // Creación de labels para trámites
    let labelsTramites = [];
    data.forEach(element => {
      labelsTramites.push(element.nombreTramite);
    });
    // Elimina los repetidos
    labelsTramites = labelsTramites.filter((item, index) => {
      return labelsTramites.indexOf(item) >= index;
    });

    // Creación de labels para estados
    this.labelsEstadosTurnosPorTramite = [];
    data.forEach(element => {
      this.labelsEstadosTurnosPorTramite.push(element.estadoTramite);
    });
    // Elimina los repetidos
    this.labelsEstadosTurnosPorTramite = this.labelsEstadosTurnosPorTramite.filter((item, index) => {
      return this.labelsEstadosTurnosPorTramite.indexOf(item) >= index;
    });

    // En caso que la cantidad de estados supere la cantidad de colores de la
    // paleta de colores entonces se agregarán más colores de forma random;
    if (this.colorPallete.length < this.labelsEstadosTurnosPorTramite.length) {
      const cant =
        this.labelsEstadosTurnosPorTramite.length - this.colorPallete.length;
      for (let index = 0; index < cant; index++) {
        this.colorPallete.push(this.randomColor(0.8));
      }
    }

    this.dataSetsTurnosPorTramite = [];

    // Genera un dataset por cada dato por trámite y estado para generar una barra individual
    this.labelsEstadosTurnosPorTramite.forEach(labelEstado => {

      const dataSet: DataSet = new DataSet();
      dataSet.label = labelEstado;
      dataSet.backgroundColor = [];
      dataSet.subLabel = [];

      const values = [];

      labelsTramites.forEach(labelTramite => {
        let aux = false;
        data.forEach(row => {
          if (row.nombreTramite === labelTramite && row.estadoTramite === labelEstado) {
            values.push(row.suma);
            dataSet.subLabel.push(labelTramite);
            dataSet.backgroundColor.push(this.colorPallete[
              this.labelsEstadosTurnosPorTramite.indexOf(labelEstado)]);
            aux = true;
          }
        });
        if (aux === false) {
          values.push(0);
          dataSet.subLabel.push(labelTramite);
          dataSet.backgroundColor.push(this.colorPallete[
            this.labelsEstadosTurnosPorTramite.indexOf(labelEstado)]);
        }
      });
      dataSet.data = values;
      this.dataSetsTurnosPorTramite.push(dataSet);
    });

    // Reorganiza la información para ser presentada en la tabla de datos fuente
    this.dataSetsTableTurnosPorTramite =
      this.reorderDataForTable(this.dataSetsTurnosPorTramite);

    const x = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labelsTramites,
        datasets: this.dataSetsTurnosPorTramite
      },
      options: {
        legend: {
          onClick({ event, legendItem }: { event; legendItem; }) { }
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }

  /**
   * Método que reorganiza los datos haciendo un corrstable o PIVOT
   * @param dataSets Datos genéricos
   */

  reorderDataForTable(dataSets: DataSet[]): DataSet[] {
    if (dataSets !== null && dataSets.length > 0) {

      const columns = dataSets[0].data.length;
      const orderDataSets: DataSet[] = [];

      for (let index = 0; index < columns; index++) {
        const orderDataSet: DataSet = new DataSet();
        orderDataSet.data = [];
        orderDataSet.subLabel = [];

        dataSets.forEach(data => {
          orderDataSet.subLabel.push(data.label);
          orderDataSet.label = data.subLabel[index];
          orderDataSet.data.push(data.data[index]);
        });

        orderDataSets.push(orderDataSet);
      }
      return orderDataSets;
    }
  }

  /**
   * Método que genera el excel del reporte turnos por trámite
   */
  generateDocExcelTramitesPorTurno() {
    this.spinner.show();
    const serviceProvider = 'turnosPorTramiteReporteExcel';
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
    this.global.getGenerico(url).subscribe(
      data => {
        if (data) {
          const datosArchivo: any = data;

          this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
          this.descargarArchivo(datosArchivo);
        } else {
          this.alertService.generateAlertError(ConstantesService.REPORTE_SIN_DATA, '');
        }
        this.spinner.hide();

      }, err => {
        if (err.status === 500) {
          this.catchException(err.error.message);
        } else {
          this.catchException('El reporte no se ha podido generar');
        }
      }
    );
  }



  /**
   * Carga el promedio de atencion por ventanilla
   * genera los datos de la tabla y crea la correspondiente gráfica.
   */
  private loadPromedioAtencionVentanilla() {
    this.isDataAviablePromedioAtencionVentanilla = false;
    this.spinner.show(this.spinnerByPromedioAtencionVentanillaId);
    this.getDataPromedioAtencionVentanilla().then(promediosAtencionVentanilla => {
      this.isDataAviablePromedioAtencionVentanilla = true;
      this.promedioAtencionVentanilla = [];
      this.promedioAtencionVentanilla = promediosAtencionVentanilla;
      this.createGraphicPromedioAtencionVentanilla(promediosAtencionVentanilla);
      setTimeout(() => {
        this.spinner.hide(this.spinnerByPromedioAtencionVentanillaId);
      }, 500);
    }).catch(err => {
      setTimeout(() => {
        this.spinner.hide(this.spinnerByPromedioAtencionVentanillaId);
      }, 500);
      console.error(err);
      this.catchException('No es posible cargar los datos para el promedio atención ventanilla');
    });
  }


  /**
   * Función que obtiene los promedios de atención por ventanilla.
   */
  private getDataPromedioAtencionVentanilla(): Promise<PromedioAtencionVentanilla[]> {
    return new Promise((resolve, reject) => {
      let promediosAtencionVentanilla: PromedioAtencionVentanilla[] = [];
      const serviceProvider = 'tiempoPromedioAtencionVentanilla';
      const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
      const promise: Promise<any> = this.global.getGenerico(url).toPromise();
      promise.then(
        data => {
          promediosAtencionVentanilla = data as PromedioAtencionVentanilla[];
          resolve(promediosAtencionVentanilla);
        }
      ).catch(err => {
        reject(err);
      });
    });
  }

  /**
   * Método que genera la gráfica de turnos por trámite a partir de los datos recibidos.
   * @param data listado de turnos por trámites.
   */
  private createGraphicPromedioAtencionVentanilla(data: PromedioAtencionVentanilla[]) {
    const ctx = this.inCanvasPromedioAtencionVentanilla.nativeElement.getContext('2d');

    this.dataSetsPromedioAtencionVentanilla = [];

    // Creación de labels para ventanillas y datos
    const values = [];
    const labelsVentanillas = [];


    const dataSet: DataSet = new DataSet();
    dataSet.backgroundColor = [];
    dataSet.data = values;
    dataSet.label = 'Promedio de atención por ventanilla en minutos';

    data.forEach(element => {
      labelsVentanillas.push(element.sede + ' - ' + element.numeroVentanilla);
      values.push(element.tiempoAtencion);
      dataSet.backgroundColor.push(this.colorPallete[0]);
    });

    this.dataSetsPromedioAtencionVentanilla.push(dataSet);

    const x = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labelsVentanillas,
        datasets: this.dataSetsPromedioAtencionVentanilla
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }

  /**
   * Método que genera el excel del reporte promedio atención por ventanilla
   */
  generateDocExcelPromedioAtencionVentanilla() {
    this.spinner.show();
    const serviceProvider = 'promedioAtencionVentanillaReporteExcel';
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
    this.global.getGenerico(url).subscribe(
      data => {
        if (data) {
          const datosArchivo: any = data;

          this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
          this.descargarArchivo(datosArchivo);
        } else {
          this.alertService.generateAlertError(ConstantesService.REPORTE_SIN_DATA, '');
        }
        this.spinner.hide();

      }, err => {
        if (err.status === 500) {
          this.catchException(err.error.message);
        } else {
          this.catchException('El reporte no se ha podido generar');
        }
      }
    );
  }

  /**
   * Carga el promedio de espera por trámite
   * genera los datos de la tabla y crea la correspondiente gráfica.
   */
  private loadPromedioEsperaTramite() {
    this.isDataAviablePromedioEsperaTramite = false;
    this.spinner.show(this.spinnerByPromedioEsperaTramiteId);
    this.getDataPromedioEsperaTramite().then(promediosAtencionVentanilla => {
      this.isDataAviablePromedioEsperaTramite = true;
      this.promedioEsperaTramite = [];
      this.promedioEsperaTramite = promediosAtencionVentanilla;
      this.createGraphicPromedioEsperaTramite(promediosAtencionVentanilla);
      setTimeout(() => {
        this.spinner.hide(this.spinnerByPromedioEsperaTramiteId);
      }, 500);
    }).catch(err => {
      setTimeout(() => {
        this.spinner.hide(this.spinnerByPromedioEsperaTramiteId);
      }, 500);
      console.error(err);
      this.catchException('No es posible cargar los datos para los promedios de espera por trámite');
    });
  }


  /**
   * Función que obtiene los promedios de espera por trámite
   */
  private getDataPromedioEsperaTramite(): Promise<PromedioEsperaTramite[]> {
    return new Promise((resolve, reject) => {
      let promediosEsperaTramite: PromedioEsperaTramite[] = [];
      const serviceProvider = 'tiempoPromedioEsperaTramite';
      const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
      const promise: Promise<any> = this.global.getGenerico(url).toPromise();
      promise.then(
        data => {
          promediosEsperaTramite = data as PromedioEsperaTramite[];
          resolve(promediosEsperaTramite);
        }
      ).catch(err => {
        reject(err);
      });
    });
  }


  /**
   * * Método que genera la gráfica de promedios de espera por trámite a partir de los datos recibidos.
   * @param data listado de promedios de espera por trámite
   */

  private createGraphicPromedioEsperaTramite(data: PromedioEsperaTramite[]) {
    const ctx = this.inCanvasPromedioEsperaTramite.nativeElement.getContext('2d');

    this.dataSetsPromedioEsperaTramite = [];

    // Creación de labels para ventanillas y datos
    const values = [];
    const labelsTramites = [];


    const dataSet: DataSet = new DataSet();
    dataSet.backgroundColor = [];
    dataSet.data = values;
    dataSet.label = 'Tiempo promedio de espera por trámite';

    data.forEach(element => {
      labelsTramites.push(element.tramiteNombre);
      values.push(element.tiempoAtencion);
      dataSet.backgroundColor.push(this.colorPallete[0]);
    });

    this.dataSetsPromedioEsperaTramite.push(dataSet);

    const x = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labelsTramites,
        datasets: this.dataSetsPromedioEsperaTramite
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }


  /**
   * Método que genera el excel del reporte promedio espera por trámite
   */
  generateDocExcelPromedioEsperaTramite() {
    this.spinner.show();
    const serviceProvider = 'promedioEsperaTramiteReporteExcel';
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
    this.global.getGenerico(url).subscribe(
      data => {

        if (data) {
          const datosArchivo: any = data;

          this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
          this.descargarArchivo(datosArchivo);
        } else {
          this.alertService.generateAlertError(ConstantesService.REPORTE_SIN_DATA, '');
        }
        this.spinner.hide();

      }, err => {
        if (err.status === 500) {
          this.catchException(err.error.message);
        } else {
          this.catchException('El reporte no se ha podido generar');
        }
      }
    );
  }

  /*
  * Método que obtiene el parámetro con el nombre TIEMPO_ACTUALIZACION_TABLERO_DE_CONTROL
  */
  public obtenerTiempoActualizacionTableroDeControl(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      const serviceProvider = 'ObtenerParametros';
      const queryParams: Array<[string, string]> = new Array<[string, string]>();
      queryParams.push(['filterBy=nombre', 'TIEMPO_ACTUALIZACION_TABLERO_DE_CONTROL']);
      const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
      this.global.getGenerico(url).subscribe(
        data => {
          if (data != null) {
            try {
              resolve(data[0].valor as number);
            } catch (err) {
              this.catchException('Error Consultando el parámetro TIEMPO_ACTUALIZACION_TABLERO_DE_CONTROL');
              resolve(120000);
            }
          }
          this.spinner.hide();
        }, err => {
          this.catchException('Error Consultando el parámetro TIEMPO_ACTUALIZACION_TABLERO_DE_CONTROL');
          this.spinner.hide();
          reject(err);
        }
      );
    });
  }


  /**
   * Método que convierte el archivo Excel y realiza la descarga del mismo
   * @function descargarArchivo
   * @return
   */
  descargarArchivo(datosArchivo: any) {
    ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      , datosArchivo.nombre, datosArchivo.archivo);
  }


  /**
   * Método de control de Excepciones
   * @function {function name}
   * @param  {type} error mensaje saliente respecto al error ocurrido
   * @return
   */
  catchException(error) {
    this.alertService.generateAlertError(error, "Error");
    this.spinner.hide();
  }

  randomScalingFactor() {
    return Math.round(Math.random() * 100);
  }
  randomColorFactor() {
    return Math.round(Math.random() * 255);
  }
  randomColor(opacity) {
    return 'rgba(' + this.randomColorFactor() + ',' + this.randomColorFactor() +
      ',' + this.randomColorFactor() + ',' + (opacity || '.8') + ')';
  }

  ngOnDestroy() {
  }

}
